export default "<section class=\"construccion\">\n    \n  <div>\n      <img src=\"assets/images/wip.png\" alt=\"\">\n  </div>\n\n</section>";